import { useContext } from 'react'
import type { FunctionComponent } from 'react'
import type { LinkResult } from '../data/LinkFragment'
import { PageThemeContext } from '../contexts/pageThemeContext'
import { contemberLinkToHref } from '../utilities/contemberLinkToHref'
import { Button } from './Button'
import { Container } from './Container'
import s from './ContentButton.module.sass'

export type ContentButtonProps = {
	link: LinkResult
	label?: string | null
}

export const ContentButton: FunctionComponent<ContentButtonProps> = ({ link, label }) => {
	const theme = useContext(PageThemeContext)

	const href = contemberLinkToHref(link)
	const buttonLabel = label ?? link.title ?? ''
	const isRedTheme = theme?.name?.toLowerCase() === 'red'

	if (!href || !buttonLabel) {
		return null
	}

	return (
		<Container>
			<div className={s.Wrapper}>
				<Button type="link" href={href} variant={isRedTheme ? 'white' : 'red'} className={s.Button}>
					{buttonLabel}
				</Button>
			</div>
		</Container>
	)
}
